import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, MessageSquare, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGlobalSettings } from "@/hooks/useGlobalSettings";
import { cn } from "@/lib/utils";

const MobileStickyCTA = () => {
  const { data: settings } = useGlobalSettings();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approximately 600px)
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 600);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Don't render if dismissed or not visible
  if (isDismissed || !isVisible) return null;

  const phone = settings?.phone;
  const phoneLink = phone ? `tel:${phone.replace(/\s/g, "")}` : null;

  return (
    <div 
      className={cn(
        "fixed bottom-0 left-0 right-0 z-50 lg:hidden",
        "bg-background/95 backdrop-blur-lg border-t border-border",
        "shadow-[0_-4px_20px_rgba(0,0,0,0.1)]",
        "animate-slide-up"
      )}
    >
      <div className="container-wide py-3 flex items-center justify-between gap-3">
        {/* Call Button */}
        {phoneLink && (
          <a
            href={phoneLink}
            className="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-colors"
          >
            <Phone className="h-5 w-5" />
            <span>Call Now</span>
          </a>
        )}

        {/* Quote Button */}
        <Link
          to="/quote"
          className="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-accent text-accent-foreground rounded-lg font-semibold hover:bg-accent/90 transition-colors"
        >
          <MessageSquare className="h-5 w-5" />
          <span>Free Quote</span>
        </Link>

        {/* Dismiss Button */}
        <button
          onClick={() => setIsDismissed(true)}
          className="p-2 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
